// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-theme-homestead -> rebel-residential-theme-homestead -> homestead
// Generated: 2026-08-26T14:38:21.360Z
// Counts: 0 design, 12 content, 5 slot group, 0 collection binding, 5 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore the neighborhood and see how connected home can feel.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_short_description"
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We are committed to ensuring digital accessibility for people with disabilities. We continually improve the user experience for everyone and apply relevant accessibility standards.</p><p>This website conforms to the <strong>Web Content Accessibility Guidelines (WCAG) 2.1 Level AA</strong>. These guidelines explain how to make web content more accessible to people with disabilities.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Homestead, polished interiors and inviting shared spaces work together to make home feel effortless. Start with a resort-style pool, fitness center, yoga and spin room, clubhouse, business center, and outdoor spaces built for grilling, gathering, or unwinding by the firepit.</p><p>Inside your apartment, modern finishes add everyday function without losing style: sleek granite countertops, stainless steel appliances, custom-patterned tile backsplashes, hardwood-inspired flooring, in-home washers and dryers, USB charging ports, and generous walk-in closets. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Have questions or need directions? Reach out to the leasing team at Homestead and let us help you explore studio, one, two, and three bedroom apartments with pet-friendly living, elegant finishes, and resort-caliber amenities.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Homestead gives you a wide range of studio, one-, two-, and three-bedroom apartments in Atlanta, from streamlined spaces with smart storage to roomier floor plans with extra bedrooms and baths. As you compare available homes, look for the details that make everyday living easier: open-concept kitchens, sleek granite countertops, stainless steel appliances, custom-patterned tile backsplashes, in-home washers and dryers, and generous walk-in closets.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Browse photos that bring the details into focus, from bright kitchens with granite countertops, stainless steel appliances, and custom-patterned tile backsplashes to open living areas with hardwood-inspired flooring and room to make each layout your own.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Homestead, your approved companion has more than a place to live—there’s space for quick outdoor breaks, a Bark Park for playtime, and a Posh Pet Spa with a pet washing station to make cleanup simple after muddy paws or rainy walks.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Tour Homestead and experience pet-friendly studio, one, two, and three bedroom apartments with elegant designer finishes, resort-caliber amenities, and five-star-inspired features. Schedule your visit today and picture what home can feel like in Atlanta.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Find Your Space"
      }
    }
  },
  "imagecallouts.tile1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-8b8f-759e-aac3-adae59543f6e.webp"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Live Better"
      },
      "subtitle": {
        "type": "GENERATOR",
        "generatedValue": "Take A Virtual Tour"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open concept living and kitchen area with a kitchen island and bar stools, a living room with a sofa and coffee table, and a balcony view."
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "/virtual-tour"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_self"
      }
    }
  },
  "imagecallouts.tile2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5c-7193-70f9-b1c3-f1e799b56969.webp"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Luxury Design"
      },
      "subtitle": {
        "type": "GENERATOR",
        "generatedValue": "View The Gallery"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern living room with gray sofa, concrete accent wall, and large TV."
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "/gallery"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_self"
      }
    }
  },
  "imagecallouts.tile3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5d-5c11-757b-8b3d-2fb5b9e2308e.webp"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Local Charm"
      },
      "subtitle": {
        "type": "GENERATOR",
        "generatedValue": "Explore The Neighborhood"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of apartment buildings with surrounding landscaping and distant cityscape."
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "/neighborhood"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_self"
      }
    }
  },
  "imagecallouts.tile4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167743/01a03e5d-6055-7251-97ab-64771c43c335.webp"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Unmatched Convenience"
      },
      "subtitle": {
        "type": "GENERATOR",
        "generatedValue": "Explore Our Amenities"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor grilling station with bar seating and a picnic table near the pool."
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "/amenities"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_self"
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
